import type { ReactNode } from 'react'

type PrimaryButtonProps = {
  icon?: ReactNode
  children: ReactNode
  onClick?: () => void
  disabled?: boolean
  buttonType?: 'button' | 'submit' | 'reset'
  variant?: 'disabled' | 'danger' | 'icon' | 'default'
}

export const PrimaryButton = ({
  icon,
  children,
  onClick,
  disabled = false,
  buttonType = 'button',
  variant = 'default',
}: PrimaryButtonProps) => {
  const buttonVariant = () => {
    switch (variant) {
      case 'icon':
        return 'pl-lg'
      case 'disabled':
        return 'bg-grayDark text-primaryText pointer-events-none'
      case 'danger':
        return 'bg-error-default text-white hover:bg-error-hover cursor-pointer'
      case 'default':
        return 'text-white bg-primaryBlue hover:bg-secondaryBlue cursor-pointer'
    }
  }

  const buttonVariantClass = buttonVariant()

  return (
    <button
      type={buttonType}
      className={`${buttonVariantClass} flex text-base font-semibold items-center gap-md px-5 py-3 justify-center rounded-sm h-fit w-fit min-w-[125px] disabled:bg-disabled disabled:cursor-not-allowed`}
      onClick={onClick}
      disabled={disabled}
    >
      {icon}
      {children}
    </button>
  )
}
